import axios from 'axios';
import { isProduction } from './InfoService';

axios.defaults.withCredentials = true;

axios.defaults.baseURL = '/crsapi/';



/**
 * Debug
 */
axios.interceptors.request.use(
    (request) => {
        console.log('Starting Request', request);
        return request;
    },
    (error) => {
        console.error('Request error', error);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        console.log('Response:', response);
        return response;
    },
    (error) => {
        console.error('Response error', error);
        return Promise.reject(error);
    }
);

